const CareerError = () => {
  return (
    <div className="container-big container-column container-error">
      <h2 className="error-heading">Fehler beim Laden ihrer Daten.</h2>
      <div className="container-error-message">
        <p>Dies kann folgende Gründe haben:</p>
        <ul>
          <li>Ihre Daten wurden nicht in die Punktetabelle eingetragen</li>
          <li>Ihre Daten wurden inkorrekt in die Punktetabelle eingetragen</li>
          <li>
            Die Verbindung zum Server konnte nicht korrekt hergestellt werden
          </li>
          <li>Es trat ein Problem mit der Anfrage auf</li>
        </ul>
        <p>
          Bitte melden Sie sich an einen <strong>Seitenadministrator</strong>{" "}
          oder öffnen sie ein <strong>Support-Ticket</strong> um die Ursache
          ihres Problems zu identifizieren.
        </p>
      </div>
    </div>
  );
};

export default CareerError;
